export async function findCountry() {
  const response = await fetch("https://ipapi.co/json/");
  const json = await response.json();
  const country = json.country;
  return country;
}